import { render, staticRenderFns } from "./trackable-link.vue?vue&type=template&id=2f323083&scoped=true&lang=pug&"
import script from "./trackable-link.vue?vue&type=script&lang=js&"
export * from "./trackable-link.vue?vue&type=script&lang=js&"
import style0 from "./trackable-link.vue?vue&type=style&index=0&id=2f323083&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f323083",
  null
  
)

export default component.exports